import { FormFieldControlled } from "components/UI/FormField/FormFieldControlled";
import { INPUT_FIELD_NAMES } from "constants/fieldNames.constans";
import { VALIDATION_SCHEMA } from "constants/validationSchema.constans";
import styles from "../index.module.scss";

export const CargoLoadOptimizerApi = () => {
  return (
    <FormFieldControlled
      rules={VALIDATION_SCHEMA.toolInfo.required}
      labelTitle="How many API calls are you planning to make per month?"
      fieldName={INPUT_FIELD_NAMES.apiPerMonth}
      className={styles.apiInput}
    />
  );
};
